import React, { useReducer, useState, useEffect, useContext } from 'react';
import { Auth } from 'aws-amplify';
import { useHistory } from 'react-router';
import { Card, Input, Progress, Row, Col, Spin } from 'antd';
import withSizes from 'react-sizes'
import Header from '../Header/index';
import NavBar from '..//Nav/index';
import Login from '../Login/index';
import isEqual from "lodash/isEqual";
import '../../assets/styles/global.scss'
import service from '../../Contexts/App/AppService';
import { AppContext, INITIAL_APP_STATE, appReducer } from '../../Contexts/App/AppContext';
import { LocalHospitalTwoTone } from '@material-ui/icons';

function Template(props) {
    const [app, appDispatcher] = useReducer(appReducer, INITIAL_APP_STATE);
    const [navBar, setnavBar] = useState({
        showNav: props.isMobileOrTab ? false : true,
        view: props.isMobileOrTab ? "mobile" : "web"
    });
    const appCtx = useContext(AppContext);
    const { isMobileOrTab } = props;
    const history = useHistory()
    const [navColSize, setnavColSize] = useState(4);
    const [contentColSize, setcontentColSize] = useState(20);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        checkSession();
    }, [])

    useEffect(() => {
        updateView()
    }, [isMobileOrTab])

    useEffect(() => {
        setLoading(appCtx.loading)
    }, [appCtx.loading])

    const checkSession = () => {
        Auth.currentSession()
            .then(session => {
                service.GetUserDetails(appCtx, res => {

                    if (res.flag) {
                        service.SetUserLogin(appCtx, true);
                        updateView(true);
                        return false;
                    } else return true;
                });
            })
            .then(ress => {
                if (ress) {
                    service.GetUserDetails(res => {
                        updateView(true);
                    });
                }
            })
            .catch(err => {
                service.SetUserLogin(appCtx, false);
                this.props.history.push('/login');
            });
    }

    const updateView = (didMount) => {
        if (isMobileOrTab && navBar.view !== "mobile") {
            let temp = navBar;
            temp.view = "mobile";
            setNav({ ...temp });
        }
        else if (navBar.view !== "web" && !didMount) {
            let temp = navBar;
            temp.view = "web";
            // temp.showNav = true;
            setNav({ ...temp });
        }
        else if (didMount)
            setdidMount()
    }
    const setdidMount = () => {
        if (isMobileOrTab) {
            let temp = navBar;
            temp.view = "mobile";
            setNav({ ...temp });
        }
        else {
            let temp = navBar;
            temp.view = "web";
            temp.showNav = true;
            setNav({ ...temp });
        }
    }
    const setNav = obj => {
        setnavBar({ ...obj });
        getNavColumnSpan({ ...obj })
        getContentSpan({ ...obj });
    }

    const getNavColumnSpan = (navBar) => {
        if (navBar) {
            if (navBar.view === "web") {
                setnavColSize(4)
            }
            else if (navBar.view === "mobile") {
                if (navBar.showNav) setnavColSize(24)
                else setnavColSize(0);
            }
        }
    }

    const getContentSpan = (navBar) => {
        if (navBar) {
            if (navBar.view === "web") {
                setcontentColSize(20)
            }
            else if (navBar.view === "mobile") {
                if (navBar.showNav) setcontentColSize(0)
                else setcontentColSize(24)
            }
        }
    }
    const getContent = () => {
        if (appCtx.login) {
            if (loading) {
                return (<Spin spinning={appCtx.loading} size="large"></Spin>);
            }
            else {
                return (
                    <Row className="hide-overflow height-100-per">
                        <Col span={navColSize} className={`left-nav ${navColSize === 0 && "display-none"}`}>
                            <NavBar navValues={navBar} setNavValues={setNav} />
                        </Col>
                        <Col span={contentColSize} className={`right-content ${contentColSize === 0 && "display-none"}`} >
                            <Header navValues={navBar} setNavValues={setNav} />
                            <>
                                {props.children}
                            </>
                        </Col>
                    </Row>
                );
            }
        }
        else {
            return <Login />;
        }
    }
    return (
        <>
            {getContent()}
        </>
    );
}

const mapSizesToProps = ({ width }) => ({
    isMobileOrTab: width < 780,
})

export default withSizes(mapSizesToProps)(Template);